import React from 'react';
import SubHeader from '../../layout/components/SubHeader';
import TemplateCard from './TemplateCard';
import './Templates.css';

function Templates() {
    return (
        <div className="ecx-page clinic-settings-page templates-page ecx-page--full-width">
            <SubHeader
                title="Templates"
                description="Manage your email, SMS, and call templates"
                icon="bi-layout-text-window"
                containerClass="w-100 px-4"
            />

            <div className="ecx-page-body">
                <TemplateCard />
            </div>
        </div>
    );
}

export default Templates;
